module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-hyundai.44047f39.jpg";